import React, { SVGProps } from 'react'
const SvgChevronLeft = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      d="m9.56 12.5 5.47-5.47a.75.75 0 1 0-1.06-1.06l-6 6a.75.75 0 0 0 0 1.06l6 6a.75.75 0 0 0 1.06-1.06L9.56 12.5Z"
    />
  </svg>
)
export default SvgChevronLeft
